import { createSlice } from "@reduxjs/toolkit";
import { aiReducers } from "./reducers/ai";
import { imageReducers } from "./reducers/images";
import { layerReducers } from "./reducers/layers";
import { positionReducers } from "./reducers/positions";
import { productReducers } from "./reducers/products";
import { defaultSession, sessionReducers } from "./reducers/session";
export * from "./selectors";

const specsEditorSlice = createSlice({
  name: "specsEditor",
  initialState: defaultSession(),
  reducers: {
    ...sessionReducers,
    ...layerReducers,
    ...imageReducers,
    ...aiReducers,
    ...positionReducers,
    ...productReducers,
  },
});

export const specsEditorActions = specsEditorSlice.actions;
export default specsEditorSlice.reducer;
